import { pulse } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
export var regular = /*#__PURE__*/css(["width:100%;border-radius:", ";", ""], pxToRem(6), pulse);
export var short = /*#__PURE__*/css(["", " width:", ";"], regular, pxToRem(60));